angular.module('bizmetryApp').controller('ResourceAttributesDialogController', function (
  $scope, $mdDialog, resource, attributes, editedTemplate, dialogService, $mdToast, $http, CONFIG, $timeout, $sce
) {

  $scope.resource = resource;
  $scope.attributes = angular.copy(attributes); // solo los del recurso actual
  $scope.resourceTypes = editedTemplate.templateConfig.resource_types;

  // Inicializar isSensitive en false si no existe
  $scope.attributes.forEach(function (attr) {
    if (attr.isSensitive === undefined) {
      attr.isSensitive = false;
    }
    if (attr.isResourceNameField === undefined) {
      attr.isResourceNameField = false;
    }
    if (attr.isResourceDescriptionField === undefined) {
      attr.isResourceDescriptionField = false;
    }
    // Inicializar JSON paths
    if (attr.resourceNameJsonPath === undefined) {
      attr.resourceNameJsonPath = null;
    }
    if (attr.resourceDescriptionJsonPath === undefined) {
      attr.resourceDescriptionJsonPath = null;
    }
  });

  console.log('RESOURCETYPES ->', $scope.resourceTypes);
  console.log('editedTemplate=', editedTemplate);
  console.log('attributes=', attributes);

  // Cargar tipos de atributo (reference data)
  $scope.resourceAttributeTypes = [];
  $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/refdata/RESOURCE_ATTRIBUTE_DATA_TYPE')
    .then(function (response) {
      // Mantener TODOS los tipos (incluyendo JSON) para que se muestre correctamente
      // cuando un atributo importado ya es JSON
      $scope.resourceAttributeTypes = response.data;
      console.log('Available attribute types:', $scope.resourceAttributeTypes.length);
    })
    .catch(function (error) {
      console.error('Error fetching resource attribute types:', error);
    });

  $scope.selectedAttributeIndex = null;
  $scope.selectAttributeType = function (idx) {
    $scope.selectedAttributeIndex = idx;
  };

  $scope.close = function () {
    if ($scope.hasAttributesChanged()) {
      dialogService.showDecisionDialog(
        'Discard Changes?',
        'You have unsaved changes. Are you sure you want to discard them?'
      ).then(function (decision) {
        if (decision === 'proceed') $mdDialog.cancel();
      });
    } else {
      $mdDialog.cancel();
    }
  };

  $scope.save = function () {
    // 1. Elimina del array global TODOS los atributos de este recurso
    var otherAttrs = (editedTemplate.templateConfig.attribute_types || []).filter(function (attr) {
      return attr.resource_id !== $scope.resource.id;
    });

    // 2. Filtramos y actualizamos los atributos del diálogo (con resource_id forzado)
    var updatedAttrs = $scope.attributes.map(function (attr) {
      var cleanAttr;

      if (attr.scalar_attribute_type === 'OBJECT_REF') {
        cleanAttr = {
          id: attr.id,
          name: attr.name,
          description: attr.description,
          enabled: attr.enabled,
          isPrimaryKey: attr.isPrimaryKey || false,
          isSensitive: attr.isSensitive || false,
          isResourceNameField: attr.isResourceNameField || false,
          isResourceDescriptionField: attr.isResourceDescriptionField || false,
          scalar_attribute_type: attr.scalar_attribute_type,
          column_metadata_name: attr.column_metadata_name,
          resource_id: $scope.resource.id,
          resourceType: {
            id: attr.resourceType.id,
            name: attr.resourceType.name
          }
        };
      } else {
        cleanAttr = {
          id: attr.id,
          name: attr.name,
          description: attr.description,
          enabled: attr.enabled,
          isPrimaryKey: attr.isPrimaryKey || false,
          column_metadata_name: attr.column_metadata_name,
          isSensitive: attr.isSensitive || false,
          isResourceNameField: attr.isResourceNameField || false,
          isResourceDescriptionField: attr.isResourceDescriptionField || false,
          scalar_attribute_type: attr.scalar_attribute_type,
          resource_id: $scope.resource.id
        };

        if (attr.scalar_attribute_type === 'JSON') {
          cleanAttr.jsonSchema = attr.jsonSchema !== undefined ? attr.jsonSchema : null;
          cleanAttr.jsonSample = attr.jsonSample !== undefined ? attr.jsonSample : null;
          if (attr.isResourceNameField && attr.resourceNameJsonPath) {
            cleanAttr.resourceNameJsonPath = attr.resourceNameJsonPath;
          }
          if (attr.isResourceDescriptionField && attr.resourceDescriptionJsonPath) {
            cleanAttr.resourceDescriptionJsonPath = attr.resourceDescriptionJsonPath;
          }
        }

        if (attr.scalar_attribute_type === 'ENUM') {
          cleanAttr.enum_values = attr.enum_values;
        }
        if (attr.scalar_attribute_type === 'INTEGER' || attr.scalar_attribute_type === 'FLOAT') {
          cleanAttr.lower_bound = attr.lower_bound;
          cleanAttr.upper_bound = attr.upper_bound;
        }
        if (attr.scalar_attribute_type === 'STRING') {
          cleanAttr.max_length = attr.max_length;
          cleanAttr.regex = attr.regex;
        }
      }

      return cleanAttr;
    });

    // 3. Actualizamos el array global en memoria (sin llamada HTTP)
    editedTemplate.templateConfig.attribute_types = otherAttrs.concat(updatedAttrs);

    // 4. Cerramos el diálogo devolviendo los atributos actualizados
    $mdDialog.hide(updatedAttrs);
  };

  // ===== PRIMARY KEY MANAGEMENT =====
  $scope.primaryKeyAttributeId = null;
  var originalPrimaryKeyAttributeId = null;

  // Inicializar al cargar los atributos
  function initializePrimaryKey() {
    // Buscar si algún atributo ya está marcado como PK
    var pkAttr = $scope.attributes.find(function (attr) {
      return attr.isPrimaryKey === true;
    });

    if (pkAttr) {
      $scope.primaryKeyAttributeId = pkAttr.id;
      originalPrimaryKeyAttributeId = pkAttr.id;
      // Asegurar que el tipo sea VARIANT
      pkAttr.scalar_attribute_type = 'VARIANT';
      console.log('Initialized Primary Key to:', pkAttr.name, 'with ID:', pkAttr.id);
    } else {
      console.log('No Primary Key found in attributes');
    }
  }

  // Handler para cuando cambia la selección de PK
  $scope.onPrimaryKeyChange = function (attributeId) {
    console.log('Primary Key changed to attribute ID:', attributeId);

    // Actualizar el modelo
    $scope.primaryKeyAttributeId = attributeId;

    // Actualizar isPrimaryKey en todos los atributos
    $scope.attributes.forEach(function (attr) {
      if (attr.id === attributeId) {
        attr.isPrimaryKey = true;
        attr.scalar_attribute_type = 'VARIANT';
        console.log('Set PK and VARIANT type for:', attr.name);

        // ✅ NUEVO: PK no puede ser sensible
        if (attr.isSensitive) {
          attr.isSensitive = false;
          console.log('Cleared isSensitive because attribute is now Primary Key');
        }

        // A primary key may also supply the resource name (whole scalar value).
        if (attr.isResourceNameField) attr.resourceNameJsonPath = null;
        // PK remains exclusive with Resource Description.
        if (attr.isResourceDescriptionField) {
          $scope.resourceDescriptionAttributeId = null;
          attr.isResourceDescriptionField = false;
          console.log('Cleared Resource Description Field because attribute is now Primary Key');
        }
      } else {
        attr.isPrimaryKey = false;
      }
    });
  };

  // Handler

  // ===== RESOURCE NAME FIELD MANAGEMENT =====
  $scope.resourceNameAttributeId = null;
  var originalResourceNameAttributeId = null;

  // Inicializar Resource Name mapping
  function initializeResourceNameField() {
    var nameAttr = $scope.attributes.find(function (attr) {
      return attr.isResourceNameField === true;
    });

    if (nameAttr) {
      $scope.resourceNameAttributeId = nameAttr.id;
      originalResourceNameAttributeId = nameAttr.id;
      console.log('Initialized Resource Name Field to:', nameAttr.name, 'with ID:', nameAttr.id);
    } else {
      console.log('No Resource Name Field found in attributes');
    }
  }

  $scope.onResourceNameChange = function (attributeId, $event) {
    console.log('Resource Name Field changed to attribute ID:', attributeId);

    // Obtener el atributo seleccionado
    var selectedAttr = $scope.attributes.find(function (a) { return a.id === attributeId; });

    // Validar: VARIANT no puede ser RN
    if (selectedAttr && selectedAttr.scalar_attribute_type === 'VARIANT' && !selectedAttr.isPrimaryKey) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }

      $mdToast.show(
        $mdToast.simple()
          .textContent('VARIANT type cannot be used as Resource Name. Use STRING, ENUM, or JSON types.')
          .position('top right')
          .theme('warn')
          .hideDelay(4000)
      );

      return false;
    }

    // Validar: Si no es JSON y ya está marcado como RD, prevenir y mostrar error
    if (selectedAttr && selectedAttr.scalar_attribute_type !== 'JSON') {
      if (attributeId === $scope.resourceDescriptionAttributeId) {
        // Prevenir el comportamiento por defecto
        if ($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }

        $mdToast.show(
          $mdToast.simple()
            .textContent('Cannot set the same attribute as both Resource Name and Resource Description. Use different attributes or switch to JSON type.')
            .position('top right')
            .theme('warn')
            .hideDelay(4000)
        );

        // NO actualizar el modelo
        return false;
      }
    }

    // Actualizar el modelo
    $scope.resourceNameAttributeId = attributeId;

    // Actualizar isResourceNameField en todos los atributos
    $scope.attributes.forEach(function (attr) {
      if (attr.id === attributeId) {
        attr.isResourceNameField = true;

        // ✅ NUEVO: RN no puede ser sensible
        if (attr.isSensitive) {
          attr.isSensitive = false;
          console.log('Cleared isSensitive because attribute is now Resource Name Field');
        }
      } else {
        attr.isResourceNameField = false;
      }
    });
  };

  // ===== RESOURCE DESCRIPTION FIELD MANAGEMENT =====
  $scope.resourceDescriptionAttributeId = null;
  var originalResourceDescriptionAttributeId = null;

  // Inicializar Resource Description mapping
  function initializeResourceDescriptionField() {
    var descAttr = $scope.attributes.find(function (attr) {
      return attr.isResourceDescriptionField === true;
    });

    if (descAttr) {
      $scope.resourceDescriptionAttributeId = descAttr.id;
      originalResourceDescriptionAttributeId = descAttr.id;
      console.log('Initialized Resource Description Field to:', descAttr.name, 'with ID:', descAttr.id);
    } else {
      console.log('No Resource Description Field found in attributes');
    }
  }

  $scope.onResourceDescriptionChange = function (attributeId, $event) {
    console.log('Resource Description Field changed to attribute ID:', attributeId);

    // Obtener el atributo seleccionado
    var selectedAttr = $scope.attributes.find(function (a) { return a.id === attributeId; });

    // Validar: PK es mutualmente exclusivo con RD
    if (selectedAttr && selectedAttr.isPrimaryKey) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }

      $mdToast.show(
        $mdToast.simple()
          .textContent('Primary Key cannot be used as Resource Description. They are mutually exclusive.')
          .position('top right')
          .theme('warn')
          .hideDelay(4000)
      );

      return false;
    }

    // Validar: VARIANT no puede ser RD
    if (selectedAttr && selectedAttr.scalar_attribute_type === 'VARIANT') {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }

      $mdToast.show(
        $mdToast.simple()
          .textContent('VARIANT type cannot be used as Resource Description. Use STRING, ENUM, or JSON types.')
          .position('top right')
          .theme('warn')
          .hideDelay(4000)
      );

      return false;
    }

    // Validar: Si no es JSON y ya está marcado como RN, prevenir y mostrar error
    if (selectedAttr && selectedAttr.scalar_attribute_type !== 'JSON') {
      if (attributeId === $scope.resourceNameAttributeId) {
        // Prevenir el comportamiento por defecto
        if ($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }

        $mdToast.show(
          $mdToast.simple()
            .textContent('Cannot set the same attribute as both Resource Name and Resource Description. Use different attributes or switch to JSON type.')
            .position('top right')
            .theme('warn')
            .hideDelay(4000)
        );

        // NO actualizar el modelo
        return false;
      }
    }

    // Actualizar el modelo
    $scope.resourceDescriptionAttributeId = attributeId;

    // Actualizar isResourceDescriptionField en todos los atributos
    $scope.attributes.forEach(function (attr) {
      if (attr.id === attributeId) {
        attr.isResourceDescriptionField = true;

        // ✅ NUEVO: RD no puede ser sensible
        if (attr.isSensitive) {
          attr.isSensitive = false;
          console.log('Cleared isSensitive because attribute is now Resource Description Field');
        }
      } else {
        attr.isResourceDescriptionField = false;
      }
    });
  };

  // ===== ATTRIBUTE TYPE CHANGE HANDLER =====
  $scope.onAttributeTypeChange = function (attr) {
    // Si el tipo cambia a VARIANT o a un tipo inválido, desmarcar RN y RD si estaban seleccionados
    var validTypes = ['STRING', 'ENUM', 'JSON'];
    var isInvalidType = validTypes.indexOf(attr.scalar_attribute_type) === -1;

    if (isInvalidType) {
      if (attr.id === $scope.resourceNameAttributeId && !attr.isPrimaryKey) {
        $scope.resourceNameAttributeId = null;
        attr.isResourceNameField = false;
        attr.resourceNameJsonPath = null;
        console.log('Cleared Resource Name Field because type changed to:', attr.scalar_attribute_type);
      }
      if (attr.id === $scope.resourceDescriptionAttributeId) {
        $scope.resourceDescriptionAttributeId = null;
        attr.isResourceDescriptionField = false;
        attr.resourceDescriptionJsonPath = null;
        console.log('Cleared Resource Description Field because type changed to:', attr.scalar_attribute_type);
      }
    }
  };

  // ===== JSON PATH SELECTOR =====
  $scope.jsonPathSelector = {
    open: false,
    attribute: null,
    mappingType: null,
    currentPath: null
  };

  $scope.openJsonPathSelector = function ($event, attr, mappingType) {
    $event.stopPropagation();

    if (!attr.jsonSample) {
      $mdToast.show(
        $mdToast.simple()
          .textContent('No JSON sample available for this attribute')
          .position('top right')
          .theme('warn')
          .hideDelay(3000)
      );
      return;
    }

    $scope.jsonPathSelector = {
      open: true,
      attribute: attr,
      mappingType: mappingType,
      currentPath: mappingType === 'RN' ? attr.resourceNameJsonPath : attr.resourceDescriptionJsonPath
    };
  };

  $scope.onJsonPathSave = function (selectedPath) {
    var attr = $scope.jsonPathSelector.attribute;
    var mappingType = $scope.jsonPathSelector.mappingType;

    var isBothRnAndRd = attr.isResourceNameField && attr.isResourceDescriptionField;
    if (isBothRnAndRd) {
      var otherPath = mappingType === 'RN' ? attr.resourceDescriptionJsonPath : attr.resourceNameJsonPath;
      if (selectedPath === otherPath && otherPath !== null) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('Resource Name and Resource Description cannot use the same JSON Path. Please select a different field.')
            .position('top right')
            .theme('warn')
            .hideDelay(4000)
        );
        return;
      }
    }

    if (mappingType === 'RN') {
      attr.resourceNameJsonPath = selectedPath;
    } else {
      attr.resourceDescriptionJsonPath = selectedPath;
    }

    $scope.jsonPathSelector.open = false;
  };

  $scope.onJsonPathCancel = function () {
    $scope.jsonPathSelector.open = false;
  };

  // ===== INITIALIZATION =====
  // Llamar todas las inicializaciones después de cargar los atributos
  initializePrimaryKey();
  initializeResourceNameField();
  initializeResourceDescriptionField();
  $scope.originalAttributes = angular.copy($scope.attributes);

  // Validación de cambios y reglas de atributos
  $scope.hasAttributesChanged = function () {
    // Comparación más robusta que detecta cambios en arrays de enum_values
    if ($scope.attributes.length !== $scope.originalAttributes.length) {
      return true;
    }

    for (var i = 0; i < $scope.attributes.length; i++) {
      var current = $scope.attributes[i];
      var original = $scope.originalAttributes[i];

      // Comparar propiedades básicas
      if (current.name !== original.name ||
        current.description !== original.description ||
        current.enabled !== original.enabled ||
        current.isPrimaryKey !== original.isPrimaryKey ||
        current.isSensitive !== original.isSensitive ||
        current.isResourceNameField !== original.isResourceNameField ||
        current.isResourceDescriptionField !== original.isResourceDescriptionField ||
        current.scalar_attribute_type !== original.scalar_attribute_type ||
        current.lower_bound !== original.lower_bound ||
        current.upper_bound !== original.upper_bound ||
        current.max_length !== original.max_length ||
        current.regex !== original.regex ||
        current.resourceNameJsonPath !== original.resourceNameJsonPath ||
        current.resourceDescriptionJsonPath !== original.resourceDescriptionJsonPath) {
        console.log('Basic property changed in attribute:', current.name);
        return true;
      }

      // Comparar enum_values (array)
      if (current.scalar_attribute_type === 'ENUM') {
        var currentValues = current.enum_values || [];
        var originalValues = original.enum_values || [];

        if (currentValues.length !== originalValues.length) {
          console.log('Enum values length changed in attribute:', current.name);
          return true;
        }

        for (var j = 0; j < currentValues.length; j++) {
          if (currentValues[j] !== originalValues[j]) {
            console.log('Enum value changed in attribute:', current.name);
            return true;
          }
        }
      }

      // Comparar resourceType para OBJECT_REF
      if (current.scalar_attribute_type === 'OBJECT_REF') {
        if (!original.resourceType || !current.resourceType ||
          current.resourceType.id !== original.resourceType.id) {
          console.log('ResourceType changed in attribute:', current.name);
          return true;
        }
      }
    }

    // Verificar cambios en Primary Key
    if (originalPrimaryKeyAttributeId !== $scope.primaryKeyAttributeId) {
      console.log('PK changed from', originalPrimaryKeyAttributeId, 'to', $scope.primaryKeyAttributeId);
      return true;
    }

    // Verificar cambios en Resource Name
    if (originalResourceNameAttributeId !== $scope.resourceNameAttributeId) {
      console.log('RN changed from', originalResourceNameAttributeId, 'to', $scope.resourceNameAttributeId);
      return true;
    }

    // Verificar cambios en Resource Description
    if (originalResourceDescriptionAttributeId !== $scope.resourceDescriptionAttributeId) {
      console.log('RD changed from', originalResourceDescriptionAttributeId, 'to', $scope.resourceDescriptionAttributeId);
      return true;
    }

    return false;
  };

  $scope.isSaveDisabled = function () {
    // Primero verificar si hay cambios
    if (!$scope.hasAttributesChanged()) {
      console.log('Save disabled: No changes detected');
      return true;
    }

    // Validar cada atributo
    var hasValidationError = $scope.attributes.some(function (attr) {
      // Solo validar atributos habilitados
      if (!attr.enabled) return false;

      // Validaciones básicas
      if (!attr.name) {
        console.log('Validation failed: Missing name for attribute');
        return true;
      }
      if (!attr.description) {
        console.log('Validation failed: Missing description for attribute:', attr.name);
        return true;
      }
      if (!attr.scalar_attribute_type) {
        console.log('Validation failed: Missing type for attribute:', attr.name);
        return true;
      }

      // Validación para ENUM
      if (attr.scalar_attribute_type === 'ENUM') {
        if (!attr.enum_values || !attr.enum_values.length) {
          console.log('Validation failed: ENUM attribute without values:', attr.name);
          return true;
        }
      }

      // Validación para OBJECT_REF
      if (attr.scalar_attribute_type === 'OBJECT_REF') {
        if (!attr.resourceType) {
          console.log('Validation failed: OBJECT_REF without resourceType:', attr.name);
          return true;
        }
      }

      // Validación para JSON con RN o RD mapeados
      if (attr.scalar_attribute_type === 'JSON') {
        if (attr.isResourceNameField && !attr.resourceNameJsonPath) {
          console.log('Validation failed: JSON RN without path:', attr.name);
          return true;
        }
        if (attr.isResourceDescriptionField && !attr.resourceDescriptionJsonPath) {
          console.log('Validation failed: JSON RD without path:', attr.name);
          return true;
        }

        // Si es tanto RN como RD, los paths deben ser diferentes
        if (attr.isResourceNameField && attr.isResourceDescriptionField) {
          if (attr.resourceNameJsonPath === attr.resourceDescriptionJsonPath && attr.resourceNameJsonPath !== null) {
            console.log('Validation failed: Same JSON path for RN and RD:', attr.name);
            return true;
          }
        }
      }

      // Validación para INTEGER/FLOAT
      if (attr.scalar_attribute_type === 'INTEGER' || attr.scalar_attribute_type === 'FLOAT') {
        if (attr.lower_bound == null || attr.upper_bound == null) {
          console.log('Validation failed: Missing bounds for numeric attribute:', attr.name);
          return true;
        }
      }

      // Validación para STRING
      if (attr.scalar_attribute_type === 'STRING') {
        if (!attr.regex || !isValidRegex(attr.regex)) {
          console.log('Validation failed: Invalid regex for STRING attribute:', attr.name);
          return true;
        }
        if (attr.max_length == null) {
          console.log('Validation failed: Missing max_length for STRING attribute:', attr.name);
          return true;
        }
      }

      return false;
    });

    if (hasValidationError) {
      console.log('Save disabled: Validation errors found');
    }

    return hasValidationError;
  };
  function isValidRegex(str) {
    if (!str) return false;
    try { new RegExp(str); return true; }
    catch (e) { return false; }
  }


  // Pill de colores (visual)
  $scope.enumPillColors = [
    '#b2ebf2', '#ffe082', '#b9f6ca', '#ffab91',
    '#ce93d8', '#80cbc4', '#ffccbc', '#f48fb1',
    '#c5e1a5', '#d7ccc8', '#fff59d', '#90caf9'
  ];
  $scope.getEnumPillStyle = function (value) {
    var colors = $scope.enumPillColors;
    var hash = 0;
    if (!value) return {};
    for (var i = 0; i < value.length; i++) {
      hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }
    var color = colors[Math.abs(hash) % colors.length];
    setTimeout(function () {
      document.querySelectorAll('md-chip .md-chip-content').forEach(function (chip) {
        if (chip.textContent.trim() === value) {
          chip.style.backgroundColor = color;
          chip.style.borderRadius = '16px';
        }
      });
    }, 10);
    return {
      'color': '#263238',
      'border-radius': '16px',
      'font-weight': 500,
      'margin-right': '3px',
      'padding': '4px 14px',
      'display': 'inline-block'
    };
  };

  $scope.addAttributeType = function () {
    var newAttr = {
      id: uuidv4(),
      name: '',
      description: '',
      scalar_attribute_type: '',
      enabled: true,
      isPrimaryKey: false,
      isSensitive: false,
      isResourceNameField: false,
      isResourceDescriptionField: false,
      resourceNameJsonPath: null,
      resourceDescriptionJsonPath: null,
      enum_values: [],
      lower_bound: null,
      upper_bound: null,
      max_length: 40,
      regex: '.*'
    };
    $scope.attributes.push(newAttr);
    $scope.selectedAttributeIndex = $scope.attributes.length - 1;
  };

  $scope.deleteAttributeType = function (idx) {
    if (idx != null && idx >= 0 && idx < $scope.attributes.length) {
      $scope.attributes.splice(idx, 1);
      $scope.selectedAttributeIndex = null;
    }
  };

  $scope.validateRegex = function (attr) {
    if (attr.scalar_attribute_type !== 'STRING') return;
    attr.regexInvalid = false;
    if (attr.regex && attr.regex.length > 0) {
      try {
        new RegExp(attr.regex);
      } catch (e) {
        attr.regexInvalid = true;
      }
    }
  };

  // Helper para UUID
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  $scope.markOrDeleteAttributeType = function (attr, index, $event) {
    $event.stopPropagation();  // Evita interferencia con selección de fila

    if (attr.markedForDeletion) {
      // Confirmado: eliminar
      $scope.attributes.splice(index, 1);
      $scope.selectedAttributeIndex = null;
    } else {
      // Marcar como pendiente de borrado
      attr.markedForDeletion = true;

      // Desmarcar los demás
      $scope.attributes.forEach(function (a) {
        if (a !== attr) a.markedForDeletion = false;
      });

      // Desmarcar automático luego de 3 segundos si no se confirma
      $timeout(function () {
        attr.markedForDeletion = false;
      }, 3000);
    }
  };

  $scope.onPrimaryKeyToggle = function (attr) {
    // Si se activa PK, forzar tipo a VARIANT
    attr.scalar_attribute_type = 'VARIANT';
    console.log('PK enabled - forced type to VARIANT for attribute:', attr.name);
    // Si se desactiva PK, no cambiamos el tipo automáticamente
    // El usuario puede elegir el tipo que quiera
  };

  // ===== JSON SCHEMA TOOLTIP =====
  $scope.toggleJsonSchemaTooltip = function ($event, attr) {
    $event.stopPropagation();

    // Aplicar posición ANTES de hacer el toggle
    attr.tooltipPosition = {
      'position': 'fixed',
      'left': '50%',
      'top': '50%',
      'transform': 'translate(-50%, -50%)',
      'z-index': '1000'
    };

    // Cerrar cualquier otro tooltip abierto
    $scope.attributes.forEach(function (a) {
      if (a !== attr) {
        a.showJsonSchemaTooltip = false;
      }
    });

    // Toggle el tooltip actual
    attr.showJsonSchemaTooltip = !attr.showJsonSchemaTooltip;
  };

  $scope.formatJsonSchema = function (jsonSchema) {
    if (!jsonSchema) return '';

    try {
      if (typeof jsonSchema === 'string') {
        var parsed = JSON.parse(jsonSchema);
        return JSON.stringify(parsed, null, 2);
      } else {
        return JSON.stringify(jsonSchema, null, 2);
      }
    } catch (e) {
      return jsonSchema;
    }
  };

  angular.element(document).on('click', function (event) {
    var isTooltip = event.target.closest('.json-schema-tooltip') !== null;
    var isButton = event.target.closest('.btn-view-schema') !== null;

    if (!isTooltip && !isButton) {
      $scope.$apply(function () {
        $scope.attributes.forEach(function (attr) {
          attr.showJsonSchemaTooltip = false;
        });
      });
    }
  });
  // ===== SENSITIVE DATA VALIDATION =====

  /**
   * Verifica si un atributo puede ser marcado como sensible
   * PK, RN y RD no pueden ser sensibles porque son datos públicos de mapeo
   * @param {Object} attr - El atributo a validar
   * @returns {Boolean} true si puede ser sensible, false si no
   */
  $scope.canBeSensitive = function (attr) {
    // No puede ser sensible si es PK, RN o RD
    return !attr.isPrimaryKey &&
      !attr.isResourceNameField &&
      !attr.isResourceDescriptionField;
  };

  /**
   * Handler cuando cambia el toggle de isSensitive
   * Valida que no se pueda marcar como sensible si es PK, RN o RD
   * @param {Object} attr - El atributo que cambió
   */
  $scope.onSensitiveChange = function (attr) {
    if (attr.isSensitive && !$scope.canBeSensitive(attr)) {
      // Revertir el cambio
      attr.isSensitive = false;

      var reason = '';
      if (attr.isPrimaryKey) {
        reason = 'Primary Key';
      } else if (attr.isResourceNameField) {
        reason = 'Resource Name Field';
      } else if (attr.isResourceDescriptionField) {
        reason = 'Resource Description Field';
      }

      $mdToast.show(
        $mdToast.simple()
          .textContent(reason + ' cannot be marked as sensitive. It is used for public resource mapping.')
          .position('top right')
          .theme('warn')
          .hideDelay(4000)
      );

      console.log('Prevented marking', attr.name, 'as sensitive because it is', reason);
      return;
    }

    // Si se activó sensitive, propagar a los FIELD_REFERENCE / OBJECT_FIELD_REF que referencien este atributo
    if (attr.isSensitive) {
      _propagateSensitiveToFrameComponents(attr.id);
    }
  };

  function _propagateSensitiveToFrameComponents(attributeTypeId) {
    var frameTypes = (
      editedTemplate.templateConfig &&
      editedTemplate.templateConfig.frame_types
    ) || [];

    var affected = 0;

    frameTypes.forEach(function (ft) {
      (ft.frame_fields || []).forEach(function (component) {
        if ((component.frame_component_type === 'FIELD_REFERENCE' ||
          component.frame_component_type === 'OBJECT_FIELD_REF') &&
          component.attribute_type_id === attributeTypeId &&
          !component.is_sensitive) {
          component.is_sensitive = true;
          affected++;
          console.log('🔒 Propagated isSensitive to ' + component.frame_component_type + ' component:',
            component.frame_field_name, 'in frame:', ft.frame_name);
        }
      });
    });

    if (affected > 0) {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Sensitive flag propagated to ' + affected +
            ' frame component' + (affected !== 1 ? 's' : '') + ' referencing this attribute.')
          .position('top right')
          .hideDelay(3500)
      );
    }
  }

});